module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    attrs: {
      "src": "https://www.changevu.com/ChangeVU-ChangeRiskMtgAgenda.pdf",
      "frameborder": "0"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-000c80f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Agenda.vue
// module id = 354
// module chunks = 5